import React from "react";

import {observer} from "mobx-react";
import {NavigationArrowForward} from "../../../core/icons/navigation-arrow-forward";
import {NavigationArrowBack} from "../../../core/icons/navigation-arrow-back";
import {ACTION_TYPES} from "../../../core/consts";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export const NewSearchWidgetBackButton = observer(({controller}) => {
  const {device, state} = controller;
  const {isListSingleView} = state;
  const {isSmallView, isRtl} = device;

  const backProps = {
    className: classNames(styles.back_button),
    onClick: () => isListSingleView ? controller.action(ACTION_TYPES.onSeeAllClick, {id: -1}) :
      controller.action(ACTION_TYPES.onSearchClick, {isVisible: false})
  }

  const iconStyle = {
    fill: useThemeColor(COLORS.textPrimary),
    width: 24,
    height: 24,
  }

  return isSmallView ? <div {...backProps}>
    {
      isRtl ? <NavigationArrowForward style={iconStyle}/> : <NavigationArrowBack style={iconStyle}/>
    }
  </div> : null
});
